import React, { useState, useEffect } from "react";
import TeaserPageNotifications from "./TeaserPageNotifications";
import { TeaserNotificationService } from "../../../utils/api";
import { useConfig } from "../../../context/ConfigContext";

const TeaserPageNotificationsComponent = () => {
  const [loading, setLoading] = useState(false);
  const [notifications, setNotifications] = useState({ cnt: [] });
  const { windowInFocus } = useConfig();

  const load = () => {
    setLoading(true);

    TeaserNotificationService()
      .then(notifications => setNotifications(notifications))
      .catch(e => {
        console.log(e);
      })
      .finally(setLoading(false));
  };

  useEffect(() => {
    let interval = null;

    if (windowInFocus) {
      load();
      interval = setInterval(load, 30 * 1000);
    }

    return () => {
      interval && clearInterval(interval);
    };
  }, [windowInFocus]);

  return <TeaserPageNotifications notifications={notifications} />;
};

export default TeaserPageNotificationsComponent;
